import { getProp as a, getColumnConfig as s } from "./utils.js";
import d from "lodash/get";
import m from "lodash/cloneDeep";
import w from "lodash/kebabCase";
const f = ",", p = `\r
`;
function b(e) {
  let n = e;
  const t = e.indexOf(f) !== -1 || e.indexOf("\r") !== -1 || e.indexOf(`
`) !== -1, i = e.indexOf('"') !== -1, o = e.indexOf("=") === 0 || e.indexOf("+") === 0 || e.indexOf("-") === 0 || e.indexOf("@") === 0;
  return i && (n = n.replace(/"/g, '""')), o && (n = `	${n}`), (t || i || o) && (n = `"${n}"`), n;
}
function h(e, n) {
  let t = "", i, o, l, r;
  for (i = 0; i < n.length; i++) {
    for (l = n[i], o = 0; o < e.length; o++) {
      let c;
      r = e[o], r.formatter ? c = r.formatter(l, r) : c = a(l, r.property), c == null && (c = ""), t = t + (o ? f : "") + b(String(c).trim());
    }
    t += p;
  }
  return t;
}
function O({ csvData: e, filename: n }) {
  if (window.navigator.msSaveBlob && window.Blob) {
    window.navigator.msSaveBlob(new Blob([e], { type: "text/csv" }), n);
    return;
  }
  const t = document.createElement("a");
  t.target = "_blank", t.download = n, window.Blob && window.URL && window.URL.createObjectURL ? t.href = window.URL.createObjectURL(new Blob([e], { type: "text/csv" })) : t.href = `data:attachment/csv;charset=utf-8,${encodeURIComponent(e)}`, document.body.appendChild(t), t.click(), document.body.removeChild(t);
}
function S(e) {
  const n = d(e.csvConfig, "columns", e.tableColumns);
  return m(n).map((t) => s(t)).filter((t) => t.property && t.downloadable);
}
function V(e) {
  const n = `${w(e.tableTitle)}-${(/* @__PURE__ */ new Date()).getTime()}.csv`, t = d(e.csvConfig, "filename", e.csvFilename) || n;
  return t.endsWith(".csv") ? t : `${t}.csv`;
}
export {
  O as downloadCSV,
  b as formatCSVField,
  S as getCSVColumns,
  V as getCSVFilename,
  h as tableToCSV
};
//# sourceMappingURL=csv.js.map
